import lottie from "lottie-web";
import animationData from "../../assets/arcware-loading.json";

export class ArcwareLogoLoader {
  public arcwareLogoLoader: HTMLDivElement;

  constructor() {
    this.arcwareLogoLoader = this.createArcwareLogoLoader();
  }

  private createArcwareLogoLoader(): HTMLDivElement {
    const arcwareLogoLoader = document.createElement("div");
    arcwareLogoLoader?.classList?.add("arcware-logo-loader");

    if (arcwareLogoLoader) {
      lottie.destroy();
      lottie.loadAnimation({
        container: arcwareLogoLoader,
        animationData: animationData,
      });
    }

    return arcwareLogoLoader;
  }
}
